module.exports = __webpack_public_path__ + "img/prompt-library.66a82c2e.svg";